module.exports = __webpack_public_path__ + "static/media/19ESCAP3.995a3996.jpg";